<div class="dialog">
  <div class="considerations" *ngFor="let consideration of considerations">
    <div class="considerations__icon">
      <flame-icon [svgIcon]="icons[consideration?.pathIcon]"></flame-icon>
    </div>
    <div class="considerations__description">
      {{ consideration.description }}
    </div>
  </div>
</div>